<template>
  <img
    :src="dark ? '/static/pop-wordmark-white.svg' : '/static/pop-wordmark.svg'"
    alt="PageOptimizer Pro"
    class="auth-logo"
    :style="{ height: `${height}px` }"
  />
</template>

<script>
// The marketing site's wordmark (SVG): grey letters and mark, gold "Pro" (Hichem, 2026-10-16); the dark
// variant is white with the gold "Pro".
export default {
  name: 'AuthLogo',
  props: {
    dark: { type: Boolean, default: false },
    height: { type: Number, default: 24 },
  },
}
</script>

<style scoped>
.auth-logo { width: auto; display: block; }
</style>
